// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1IOPN","list":"styles_list__3QLGT"};